import React, { useEffect, useMemo, useState } from "react";
import { Row, Col } from "antd";
import "./Reports.less";
import { ReportsCatalog } from "./ReportsCatalog/ReportsCatalog";
import { MetabaseAppEmbed } from "./MetabaseAppEmbed/MetabaseAppEmbed";
import { useAppDispatch, useAppSelector } from "../..";
import { getReport, getReportsCatalog, resetReportUrl } from "../../store/slices/reports";
import { checkIsLoading } from "../../lib/utils";
import { ReportsSelectedFilterValues } from "./ReportsCatalog/ReportsTypes";

const Reports = () => {
  const dispatch = useAppDispatch();
  const { reportUrl, reportUrlLoading } = useAppSelector((state) => state.reports);

  const initialSearchValues: ReportsSelectedFilterValues = {
    reportId: undefined,
    reportGroupId: undefined,
  };

  const [isCatalogOpen, setIsCatalogOpen] = useState(true);
  const [searchListValues, setSearchListValues] = useState(initialSearchValues);
  const [catalogExpandedKeys, setCatalogExpandedKeys] = useState<string[]>([]);

  const onChangeSearchValue = (field: ReportsSelectedFilterValues) => {
    setSearchListValues((prev) => {
      const values = { ...prev, ...field };
      return values;
    });

    if (field.reportId) {
      dispatch(getReport(Number(field.reportId)));
    }
  };

  const caltalogSpan: number = useMemo(() => (isCatalogOpen ? 5 : 1), [isCatalogOpen]);

  const toggleCatalogOpen = () => {
    setIsCatalogOpen((prev) => !prev);
  };

  useEffect(() => {
    dispatch(getReportsCatalog());
    return () => {
      dispatch(resetReportUrl());
    };
  }, []);

  return (
    <div className="reports-container">
      <h1>Отчёты</h1>
      <Row>
        <Col className="reports-list__left" span={caltalogSpan}>
          <ReportsCatalog
            isCatalogOpen={isCatalogOpen}
            toggleCatalogOpen={toggleCatalogOpen}
            onChangeSearchValue={onChangeSearchValue}
            searchListValues={searchListValues}
            catalogExpandedKeys={catalogExpandedKeys}
            setCatalogExpandedKeys={setCatalogExpandedKeys}
          />
        </Col>
        <Col className="reports-list__right" span={24 - caltalogSpan}>
          <MetabaseAppEmbed
            isLoading={checkIsLoading(reportUrlLoading)}
            reportUrl={reportUrl}
            className={undefined}
            onMessage={undefined}
            onLocationChange={undefined}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Reports;
